<template>
  <div id="reportTable" :class="{scoresSection : tablePick === 'Score'}">
    <b-row v-if="this.$route.name == 'tournament' || this.$route.name == 'qsctournament'">
      <span class="reportsPad">
            <b-col lg="12" class="dropSel">
                <b-row class="reportDropdown">
                    <b-col lg="12">
                      <span class="spanSelectReport">
                        <h2 class="reportSelect" v-if="Array.isArray(tmparams.reports.reports_entry)">Select Report</h2>
                        <div :class="drop">
                            <b-nav card-header pills>
                                <b-dropdown
                                    v-if="Array.isArray(tmparams.reports.reports_entry)"
                                    :text="title"
                                    class="dropdownReport"
                                >
                                    <b-dropdown-item
                                    v-on:click="changeReport"
                                    v-for="(reports, index) in filterExemptions"
                                    :key="index"
                                    v-show="
                                        reports.report_title !== 'Live Scoring Monitor'
                                    "
                                    :title="reports.report_url"
                                    :value="reports.report_title"
                                    >{{ reports.report_title }}</b-dropdown-item
                                    >
                                </b-dropdown>
                            </b-nav>
                        </div>
                      </span>
                    </b-col>
                </b-row>
            </b-col>
      </span>
    </b-row>
    <div class="title" :class="{titleScore : title.includes('Score'), inforPageOnly : this.$route.name == 'tournament' || this.$route.name == 'qsctournament'}">
      <template v-if="useName == 'N'">
      <h3 v-if="home === false">{{ data.short_name }} - {{ title }}</h3>
      </template>
      <template v-else>
      <h3 v-if="home === false">{{ data.full_name }} - {{ title }}</h3>
      </template>
      <p class="showDesk">
        <span v-if="home === false">
          {{ data.course_dates }}
        </span>
        <span v-else class="homeCourse">
          {{ data.course_dates }}
        </span>
        <span v-if="tablePick === 'Score' || tablePick === 'Live'">
          <br />
          Last Real Time Update - {{ localTime }}
          <span v-if="tablePick === 'Score' || tablePick === 'Live'">{{
            data.last_scores_update_date
          }}</span
          >{{ data.course_city }} -
          <span v-if="tablePick === 'Score' || tablePick === 'Live'"
            >{{ data.last_scores_update_time }}
            {{ data.last_scores_update_date }}</span
          ></span
        >
        <br />
        <span v-if="data.pft_time !== '' && tablePick === 'Live'">
          Projected Finish Time - {{ data.pft_time }}
        </span>
      </p>
      <p
        v-if="
          tablePick === 'Live' ||
            (tablePick === 'Score' && data.live_scoring === 'Y')
        "
        style="text-align: right;"
      >
        *Did not start from 1st Hole.
      </p>
    </div>
    <table>
      <thead></thead>
      <tbody>
        <template v-if="tablePick === 'Entries'">
          <Entries
            :data="data"
            :previousData="previousData"
            :home="home"
            :title="title"
            :config="config"
            :updown="updown"
            :show_info_web="show_info_web"
            :hide_score_card="hide_score_card"
          />
        </template>
        <template v-if="tablePick === 'Draw'">
          <Draw
            :data="data"
            :previousData="previousData"
            :home="home"
            :title="title"
            :config="config"
            :updown="updown"
            :show_info_web="show_info_web"
            :hide_score_card="hide_score_card"
          />
        </template>
        <template v-if="tablePick === 'Score' || tablePick === 'Live'">
          <Score
            :data="data"
            :previousData="previousData"
            :home="home"
            :title="title"
            :config="config"
            :team="team"
            :match="match"
            :updown="updown"
            :showGender="showGender"
            :represents_ind="represents_ind"
            :represents_heading="represents_heading"
            :represents_flag_type="represents_flag_type"
            :is_qualifier="is_qualifier"
            :show_info_web="show_info_web"
            :hide_score_card="hide_score_card"
          />
        </template>
        <template v-if="tablePick === 'Final'">
          <Results
            :data="data"
            :dataShowOOM="data.show_winnings"
            :dataHavePoints="data.have_points"
            :dataShowPointsName="data.show_points_name"
            :dataHaveOom="data.have_oom"
            :previousData="previousData"
            :home="home"
            :title="title"
            :config="config"
            :team="team"
            :match="match"
            :updown="updown"
            :showGender="showGender"
            :is_qualifier="is_qualifier"
            :represents_ind="represents_ind"
            :represents_heading="represents_heading"
            :represents_flag_type="represents_flag_type"
            :show_info_web="show_info_web"
            :hide_score_card="hide_score_card"
            :id="id"
            :season="season"
            :code="code"
            :Stableford="Stableford"
          />
        </template>

        <!-- <template v-for="(tabledata, index) in Eds">
          <tr @click.stop="rowClicked(index)" :key="index">
          </tr>
          <tr
            @click.stop="rowClicked(rowClicked === -1)"
            v-if="index === clickedRow"
            class="tr-kids"
            :key="index + Math.random()"
          >
            <td id="reportCard" colspan="11">
              <PlayerReportCard
                :playerData="playerData"
                :data="data"
                :config="config"
                :round="data.round"
                :actualRound="data.pft_round"
                :roundsPlayed="data.pft_round"
              />
            </td>
          </tr>
        </template> -->
        <template>
          <div class="LiveScoreMess" v-if="data.live_scoring_mess">
            <p class="LiveScoreMessPara">{{ data.live_scoring_mess }}</p>
          </div>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
import {
  Entries,
  Draw,
  Score,
  Results
} from "@ocs-software/vue-ocs";
import axios from 'axios';
export default {
  name: "reportTable",
  props: [
    "data",
    "previousData",
    "home",
    "title",
    "updown",
    "config",
    "match",
    "showGender",
    "Stableford",
    "represents_ind",
    "represents_heading",
    "represents_flag_type",
    "showFav",
    "is_qualifier",
    "team",
    "show_info_web",
    "hide_score_card",
    "useName",
    "id",
    "code",
    "season",
    "tmparams"
  ],
  components: { Entries, Draw, Score, Results },
  data() {
    return {
      up: "up",
      down: "down",
      scores: [],
      clickedRow: -1,
      cardID: [],
      playerCardData: []
    };
  },
  methods: {
    changeReport: function(event) {
      console.log('Change report')
      var report = event.target.getAttribute("title");
      console.log("report")
      console.log(report)
      var title = event.target.getAttribute("value");
      console.log("title")
      console.log(title)
      this.title = title;
      return (
        (this.currentReport = report),
        (console.log("this.currentReport")),
        (console.log(this.currentReport)),
        axios
          .get(this.reportTitle)
          .then(response => 
            (this.data = response.data),
            (console.log("this.data")),
            (console.log(this.data)),
            console.log("this.reportTitle"),
            console.log(this.reportTitle),
          )
      );
    },
    range: function(start, end) {
      if (this.roundsPlayed === 1) return this.roundsPlayed;
      else
        return Array(end - start + 1)
          .fill()
          .map((_, idx) => start + idx);
    },
    rowClicked: function(index) {
      if (this.tablePick === "Score" && this.clickedRow !== index)
        this.clickedRow = index;
      else this.clickedRow = -1;
    },
    playerCard: function(playerNo) {
      var playerData = {};
      console.log("playerData");
      console.log(playerData);
      var cardID = playerNo;
      console.log("cardID");
      console.log(cardID);
      for (var i of this.data.scores.scores_entry) {
        console.log("in scores");
        if (i.member_no == playerNo) {
          this.playerData = i;
          console.log("playerData 384");
          console.log(this.playerData);
          break;
        }
      }
    }
  },
  computed: {
    filterExemptions: function() {
      return this.tmparams.reports.reports_entry.filter(
        reports_entry =>
          !reports_entry.report_title.indexOf("Tournament Entries") ||
          !reports_entry.report_title.indexOf("Round 1 Draw") ||
          !reports_entry.report_title.indexOf("Round 2 Draw") ||
          !reports_entry.report_title.indexOf("Round 3 Draw") ||
          !reports_entry.report_title.indexOf("Round 4 Draw") ||
          !reports_entry.report_title.indexOf("Round 5 Draw") ||
          !reports_entry.report_title.indexOf("Round 6 Draw") ||
          !reports_entry.report_title.indexOf("Round 1 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 2 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 3 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 4 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 5 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 6 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 2 Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 3 Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 4 Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 5 Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 6 Scoreboard") ||
          !reports_entry.report_title.indexOf("Final Result") 
          // !reports_entry.report_title.indexOf("Live Scoring Monitor")
      );
    },
    reportTitle: function(url) {
        if (this.$route.name == 'qsctournament') {
          if (this.tablePick === "Entries") {
            url =
              'https://api.euro.ocs-software.com/ffg/cache/qsc/' +
              this.id +
              "/" +
              this.id +
              "-" +
              this.code +
              "-entry-entries.json";
          } else {
            if (this.currentReport.indexOf("tmscore") !== -1) {
              var subRep3 = this.currentReport.lastIndexOf("params=") + 7;
              var indNext3 = this.currentReport.indexOf("~", subRep3);
              var repParams1 = this.currentReport.substr(
                subRep3,
                indNext3 - subRep3
              );

              if (repParams1 && repParams1.indexOf(".cgi") < 0) {
                url =
                  'https://api.euro.ocs-software.com/ffg/cache/qsc/' +
                  this.id +
                  "/" +
                  this.id +
                  "-" +
                  this.code +
                  "-scores-" +
                  repParams1 +
                  ".json" +
                  "?randomadd=" +
                  new Date().getTime();
              } else {
                url =
                  'https://api.euro.ocs-software.com/ffg/cache/qsc/' +
                  this.id +
                  "/" +
                  this.id +
                  "-" +
                  this.code +
                  "-scores-latest.json" +
                  "?gt=y&randomadd=" +
                  new Date().getTime();
              }
            } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
              {
                url =
                  'https://api.euro.ocs-software.com/ffg/cache/qsc/' +
                  this.id +
                  "/" +
                  this.id +
                  "-" +
                  this.code +
                  "-scores-latest.json" +
                  "?gt=y&randomadd=" +
                  new Date().getTime();
              }
            } else if (this.tablePick === "Draw") {
              var subRep5 = this.currentReport.lastIndexOf("round=") + 6;
              var indNext5 = this.currentReport.indexOf("~", subRep5);
              var drawRnd1 = this.currentReport.substr(subRep5, indNext5 - subRep5);
              url =
                'https://api.euro.ocs-software.com/ffg/cache/qsc/' +
                this.id +
                "/" +
                this.id +
                "-" +
                this.code +
                "-draw-R" +
                drawRnd1 +
                "-draw.json";
            } else if (this.tablePick === "Final Result") {
              var subRep4 = this.currentReport.lastIndexOf("result=") + 7;
              var indNext4 = this.currentReport.indexOf("~", subRep4);
              var resNum2 = this.currentReport.substr(
                subRep4,
                indNext4 - subRep4
              );
              // console.log("resNum === ");
              // console.log(resNum1);
              url =
                'https://api.euro.ocs-software.com/ffg/cache/qsc/' +
                this.id +
                "/" +
                this.id +
                "-" +
                this.code +
                "-result-result-" +
                resNum2 +
                ".json";
            } else {
              url =
                'https://api.euro.ocs-software.com/ffg/cache/qsc/' +
                this.id +
                "/" +
                this.id +
                "-" +
                this.code +
                "-result-result-PF.json";
            }
          }
          return url;           
        } else {
          if (this.tablePick === "Entries") {
            url =
              process.env.VUE_APP_APIFULL_URL +
              this.id +
              "/" +
              this.id +
              "-" +
              this.code +
              "-entry-entries.json";
          } else {
            if (this.currentReport.indexOf("tmscore") !== -1) {
              var subRep2 = this.currentReport.lastIndexOf("params=") + 7;
              var indNext2 = this.currentReport.indexOf("~", subRep2);
              var repParams = this.currentReport.substr(
                subRep2,
                indNext2 - subRep2
              );

              if (repParams && repParams.indexOf(".cgi") < 0) {
                url =
                  process.env.VUE_APP_APIFULL_URL +
                  this.id +
                  "/" +
                  this.id +
                  "-" +
                  this.code +
                  "-scores-" +
                  repParams +
                  ".json" +
                  "?randomadd=" +
                  new Date().getTime();
              } else {
                url =
                  process.env.VUE_APP_APIFULL_URL +
                  this.id +
                  "/" +
                  this.id +
                  "-" +
                  this.code +
                  "-scores-latest.json" +
                  "?gt=y&randomadd=" +
                  new Date().getTime();
              }
            } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
              {
                url =
                  process.env.VUE_APP_APIFULL_URL +
                  this.id +
                  "/" +
                  this.id +
                  "-" +
                  this.code +
                  "-scores-latest.json" +
                  "?gt=y&randomadd=" +
                  new Date().getTime();
              }
            } else if (this.tablePick === "Draw") {
              var subRep = this.currentReport.lastIndexOf("round=") + 6;
              var indNext = this.currentReport.indexOf("~", subRep);
              var drawRnd = this.currentReport.substr(subRep, indNext - subRep);
              url =
                process.env.VUE_APP_APIFULL_URL +
                this.id +
                "/" +
                this.id +
                "-" +
                this.code +
                "-draw-R" +
                drawRnd +
                "-draw.json";
            } else if (this.tablePick === "Final Result") {
              var subRep1 = this.currentReport.lastIndexOf("result=") + 7;
              var indNext1 = this.currentReport.indexOf("~", subRep1);
              var resNum1 = this.currentReport.substr(
                subRep1,
                indNext1 - subRep1
              );
              // console.log("resNum === ");
              // console.log(resNum1);
              url =
                process.env.VUE_APP_APIFULL_URL +
                this.id +
                "/" +
                this.id +
                "-" +
                this.code +
                "-result-result-" +
                resNum1 +
                ".json";
            } else {
              url =
                process.env.VUE_APP_APIFULL_URL +
                this.id +
                "/" +
                this.id +
                "-" +
                this.code +
                "-result-result-PF.json";
            }
          }
          return url; 
        }
    },
    localTime: function(local) {
      var today = new Date();
      if (this.tablePick === "Final") {
        local = today.getHours() + ":" + today.getMinutes();
      } else {
        local =
          today.getHours() +
          ":" +
          today.getMinutes() +
          ":" +
          today.getSeconds();
      }
      return local;
    },
    tablePick: function(picked) {
      if (this.title.includes("Tournament Entries")) picked = "Entries";
      else if (this.title.includes("Draw")) picked = "Draw";
      else if (
        (this.title.includes("Scores") && this.data.live_scoring === "N") ||
        (this.title.includes("Scoreboard") && this.data.live_scoring === "N")
      )
        picked = "Score";
      else if (
        (this.title.includes("Scores") && this.data.live_scoring === "Y") ||
        (this.title.includes("Scoreboard") && this.data.live_scoring === "Y")
      )
        picked = "Live";
      else if (this.title.includes("Final")) picked = "Final";
      else if (this.title.includes("Live")) picked = "Live";
      return picked;
    },
    roundsPlayed() {
      return parseInt(this.data.rounds_played);
    },
    ud(way) {
      if (this.updown === false) way = 4;
      else way = 10;
      return way;
    },
    Eds(reportData) {
      var ud = this.ud;
      if (this.home === false) {
        if (this.title.includes("Tournament Entries"))
          reportData = this.data.entries.entries_entry;
        else if (this.title.includes("Draw"))
          reportData = this.data.draw.draw_entry;
        else if (
          this.title.includes("Scores") ||
          this.title.includes("Scoreboard") ||
          this.title.includes("Live")
        )
          reportData = this.data.scores.scores_entry;
        else if (this.title.includes("Final"))
          reportData = this.data.result.result_entry;
        return reportData;
      } else {
        if (this.title === "Tournament Entries")
          reportData = this.data.entries.entries_entry.slice(0, ud);
        else if (this.title.includes("Draw"))
          reportData = this.data.draw.draw_entry.slice(0, ud);
        else if (
          this.title.includes("Scores") ||
          this.title.includes("Scoreboard") ||
          this.title.includes("Live")
        )
          reportData = this.data.scores.scores_entry.slice(0, ud);
        else if (this.title.includes("Final"))
          reportData = this.data.result.result_entry.slice(0, ud);
        return reportData;
      }
    }
  },
  watch: {
    Eds(newValue, oldValue) {
      newValue.forEach((value1, key1) => {
        oldValue.forEach((value2, key2) => {
          if (value1.id === value2.id) {
            if (key1 < key2) {
              value1.posChang = "up";
            } else if (key1 > key2) {
              value1.posChang = "down";
            }
          }
        });
      });

      console.log(newValue);
    },
    immediate: true,
    deep: true
  },
  filters: {
    lowercase: function(value) {
      if (!value) {
        return "";
      }
      return value.toLowerCase() + ".svg";
    }
  }
};
</script>

<style scoped>
span.reportsPad {
  margin: auto;
  margin-bottom: 30px;
  margin-top: 30px;
}
::v-deep .title {
    /* display: none; */
}
::v-deep tbody {
  font-size: 1rem;
}
.homeCourse {
  margin-top: 20px;
  display: none;
}
p.LiveScoreMessPara {
  color: #fff;
  padding-top: 15px;
}
.LiveScoreMess {
  background: red;
  text-align: center;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 99;
  margin: auto;
  left: 0;
  right: 0;
}
.drawPos {
  max-width: 100% !important;
  text-align: -webkit-center !important;
  margin-top: 0px !important;
}
.title {
  padding-top: 20px;
  padding-bottom: 20px;
  /* border-top-left-radius: 30px!important;
  border-top-right-radius: 30px!important; */
  background-color: #4E5F9B;
}
.title.titleScore {
  border-top-left-radius: 0px!important;
  border-top-right-radius: 0px!important;
}
.catD {
  text-align: center;
  background-color: #263056;
  color: white;
}
::v-deep .nav-tabs {
  border-bottom: 0px solid #dee2e6;
}

.title > h3 {
  padding-top: 8px;
  margin-bottom: 0px;
  font-size: 24px;
}
.title > p {
  font-size: 16px;
  margin-bottom: 0;
}
th {
  position: sticky;
  /* top: 0; */
  background-color: #263056;
  color: white !important;
  font-weight: 400;
}
table {
  width: 100%;
}
thead > tr {
  color: white;
}
td:nth-child(2) {
  width: 34%;
  padding: 6px;
}
td:first-child {
  text-align: center;
}
th:first-child {
  text-align: center;
}
th:nth-child(3) {
  text-align: center;
}
td:nth-child(3) {
  text-align: center;
}
.even {
  background-color: white !important;
}
.odd {
  background-color: #dfe1e6 !important;
}
tr:nth-child(odd) {
  background-color: #dfe1e6;
}
tr:nth-child(even) {
  background-color: #fff;
}
td {
  font-weight: 500;
}

td.posnum {
  padding: 5px;
  background-color: #263056;
  color: #ffffff;
  padding-top: 4px;
  padding-bottom: 4px;
  display: block;
  max-width: 58px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 2px;
  margin-bottom: 0px;
}
td.posnum > span {
  padding: 5px;
  background-color: #263056;
  color: #ffffff;
  display: block;
  max-width: 58px;
}
.noPos > span {
  color: transparent;
  padding: 5px;
  display: block;
  max-width: 58px;
}
.flag {
  width: 30px;
  box-shadow: 0 0 3px #555;
}
.up {
  color: #a52a2a;
}
.down {
  color: #1e90ff;
}
.text-down {
  background: transparent;
  text-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
  animation: glow-red 2s infinite;
  animation-iteration-count: 6;
}

@keyframes glow-red {
  to {
    text-shadow: 0 0 10px rgba(255, 82, 82, 0.7);
  }
}

.text-up {
  background: transparent;
  text-shadow: 0 0 0 0 rgba(51, 217, 178, 1);
  animation: glow-green 2s infinite;
  animation-iteration-count: 6;
}

@keyframes glow-green {
  to {
    text-shadow: 0 0 10px rgba(51, 217, 178, 0.7);
  }
}
.cut {
  padding-top: 6px !important;
  padding-right: 6px !important;
  padding-bottom: 6px !important;
  font-size: 19px !important;
  vertical-align: middle;
  padding-left: 8px !important;
  background: #aa0003;
  color: white;
}

@media only screen and (max-width: 990px) {
  .showDesk {
    display: none;
  }
}
@media only screen and (max-width: 768px) {
  .title > h3 {
    font-size: 13px !important;
  }
  .title > p {
    font-size: 12px !important;
  }
  th {
    font-size: 13px !important;
  }
  td {
    font-size: 13px !important;
  }
}
svg.userIcon.svg-inline--fa.fa-user.fa-w-14 {
  color: #007cba;
}
</style>
<style scoped src="@/css/entries.css"></style>
<style scoped src="@/css/draw.css"></style>
<style src="@/css/scoresOnly.css"></style>
<style src="@/css/teamscoresOnly.css"></style>
<style src="@/css/hbh.css"></style>
<style src="@/css/results.css"></style>
<style src="@/css/orginalReportCard.css"></style>
<style src="@/css/playerReportCard.css"></style>